/* Desktop-only slider for the "You may also like" section.
   Recommendations are fetched by <product-recommendations> (global.js); this waits for
   the markup to land, then turns the grid into a Swiper on screens 990px and up. */
(function () {
  var DESKTOP = window.matchMedia('(min-width: 990px)');
  var instances = new WeakMap();

  function columnsFor(el, width) {
    var max = parseInt(el.dataset.columns, 10) || 4;
    var cols = width >= 1600 ? 6 : width >= 1360 ? 5 : width >= 1100 ? 4 : 3;
    return Math.min(max, cols);
  }

  function placeArrows(el) {
    var image = el.querySelector('.card__inner');
    if (!image) return;
    var top = image.offsetHeight / 2;
    el.querySelectorAll('.product-recommendations__arrow').forEach(function (a) {
      a.style.top = top + 'px';
    });
  }

  function build(el) {
    if (instances.has(el) || typeof Swiper === 'undefined') return;
    el.classList.add('is-slider');
    var swiper = new Swiper(el.querySelector('.product-recommendations__viewport') || el, {
      wrapperClass: 'product-recommendations__wrapper',
      slideClass: 'product-recommendations__item',
      slidesPerView: columnsFor(el, window.innerWidth),
      spaceBetween: 24,
      speed: 600,
      watchOverflow: true,
      navigation: {
        prevEl: el.querySelector('.product-recommendations__arrow--prev'),
        nextEl: el.querySelector('.product-recommendations__arrow--next'),
        disabledClass: 'is-disabled',
        lockClass: 'is-locked'
      },
      on: {
        init: function () { placeArrows(el); },
        resize: function (s) {
          var cols = columnsFor(el, window.innerWidth);
          if (s.params.slidesPerView !== cols) { s.params.slidesPerView = cols; s.update(); }
          placeArrows(el);
        }
      }
    });
    instances.set(el, swiper);
  }

  function teardown(el) {
    var swiper = instances.get(el);
    if (!swiper) return;
    swiper.destroy(true, true);
    instances.delete(el);
    el.classList.remove('is-slider');
    el.querySelectorAll('.product-recommendations__arrow').forEach(function (a) { a.style.top = ''; });
  }

  function sync() {
    document.querySelectorAll('.js-recommendations-desktop-slider').forEach(function (el) {
      DESKTOP.matches ? build(el) : teardown(el);
    });
  }

  function watch(host) {
    if (host.dataset.recSliderWatched) return;
    host.dataset.recSliderWatched = '1';
    new MutationObserver(sync).observe(host, { childList: true, subtree: true });
    sync();
  }

  function start() {
    document.querySelectorAll('product-recommendations').forEach(watch);
  }

  DESKTOP.addEventListener ? DESKTOP.addEventListener('change', sync) : DESKTOP.addListener(sync);
  document.addEventListener('shopify:section:load', start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
